import { FormEntryContext } from "components/collectionsForm";
import { UserContext } from "components/user";
import { useCallback, useContext, useEffect, useState } from "react";
import { FailedFile, UploadFile } from "./FileChips";
import { uploadFile } from ".";
import { detectMatchingFiles, FileResolution, Resolution } from "./MatchingFileDialog";
import CartaFsClient from "@contextualize/cartafs/dist/CartaFsClient";

export default function useFileUpload(multiple: boolean, currentValue: string | string[], onResult: (result: string | string[])=>void,onError: (e: any)=>void){

    
    const { carta } = useContext(UserContext);
    const schemaContext = useContext(FormEntryContext)
    
    const [uploading, setUploading] = useState<UploadFile[]>([]);
    
    const [actionableFiles, setActionableFiles] = useState<FileResolution[]>([]);

    const [pendingUpload, setPendingUpload] = useState<FileResolution[] | undefined>();

    const [cartaFs, setCartaFs] = useState<CartaFsClient>();

    const [errorFiles, setErrorFiles] = useState<FailedFile[]>([]);

    useEffect(()=>{
        if(!carta){
            return;
        }
        setCartaFs(new CartaFsClient(carta));
    }, [carta])

    useEffect(() => {
        if(!pendingUpload){
            return;
        }
        (async ()=>{
            const _pendingUpload = pendingUpload;
            setPendingUpload(undefined);
            setErrorFiles([]);

            const uploadResult = await uploadFile(multiple, cartaFs, schemaContext, currentValue, _pendingUpload, setUploading, setErrorFiles);
            onResult(uploadResult);
        })()
    }, [schemaContext, cartaFs, currentValue, multiple, pendingUpload, setErrorFiles, onResult])

    const onFileAdded = useCallback(async (files: FileList | undefined | null) => {
        if(uploading.length > 0){
            throw new Error("Please wait for current upload to complete before adding more files");
        }
        if(files){
            const {files: fileResolutions, unresolved} = detectMatchingFiles(files, currentValue);
            if(unresolved > 0){
                if(multiple){
                    setActionableFiles(fileResolutions)
                }else{
                    fileResolutions[0].resolution = Resolution.Replace;
                    setPendingUpload(fileResolutions);
                }
            }else{
                setPendingUpload(fileResolutions);
            }
        }
    }, [currentValue, uploading, multiple])

    return {
        cartaFs,
        schemaContext,
        uploading,
        actionableFiles: {actionableFiles, setActionableFiles},
        pendingUpload: {pendingUpload, setPendingUpload},
        onFileAdded,
        errorFiles
    }
}